__turbopack_context__.v({
  "boundary": "iWMvkq_boundary",
});
